export const OPEN_INTERFACE_ROLE_SECTION = 'app.ext.load.module.openinterface';

export const DEFAULT_PAGE_SIZE = 10;
